module.exports = "https://la-static.vkplay.ru/promo/newstart/img/bard.922b28ab.png";